import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { SYSTEM_DEFAULTS } from "../util/constants"
import NotificationBell from "./notificationsHeader";

export default function DashboardHeader() {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    const storedUser = JSON.parse(localStorage.getItem(SYSTEM_DEFAULTS.USER_CACHE));

    useEffect(() => {
        function handleClickOutside(e) {
          if (menuRef.current && !menuRef.current.contains(e.target)) {
            setMenuOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = async () => {
        localStorage.removeItem(SYSTEM_DEFAULTS.USER_CACHE);
        localStorage.removeItem(SYSTEM_DEFAULTS.REFRESH_TOKEN);
        localStorage.removeItem(SYSTEM_DEFAULTS.ACCESS_TOKEN);
        await fetch(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/logout`);
        navigate("/login");
    };

    return (
        <div className="dashboard-header">
          <div className="logo">
            <span className="logo-icon">
              <img
                src="/images/logo.svg"
                alt="wengmack"
                className="img-fluid dashboard-logo"
              />
            </span>
          </div>
          <div className="header-actions">
            <div className="search-box">
              <input type="text" placeholder="search" />
              <span className="search-icon"><i className="bi bi-search"></i></span>
            </div>
            <NotificationBell />
            <div 
              className="user-profile" 
              ref={menuRef} 
              onClick={() => setMenuOpen(prev => !prev)}
              style={{ cursor: "pointer", position: "relative" }}
            >
              <span className="user-name">{storedUser?.first_name || "User"}</span>
              <div className="user-avatar"><i className="bi bi-person"></i></div>
    
              {menuOpen && (
                <div className="profile-menu">
                  <div onClick={() => navigate("/profile")}>Profile</div>
                  <div onClick={() => navigate("/settings")}>Settings</div>
                  <div className="logout" onClick={handleLogout}>Logout</div>
                </div>
              )}
            </div>
          </div>
        </div>
    );
}